import { ListenableSubscribable } from '@benzinga/subscribable';
import { GptSearchEvent } from './manager';
import { GptResponseData } from './entity';
export class GptSearchStore<T extends object = object> extends ListenableSubscribable<GptSearchEvent> {
  private data: GptResponseData<T>[];

  constructor() {
    super();
    this.data = [];
  }

  public getCachedData = () => this.data;

  public getCachedWithPromptData = (prompt: string): GptResponseData<T> | undefined =>
    this.data.find(d => d.prompt === prompt);
  public updatePromptCachedData = (prompt: string, completions) => {
    const index = this.data.findIndex(d => d.prompt === prompt);
    if (index !== -1) {
      this.data[index] = { completions, prompt };
    } else {
      this.data.push({ completions, prompt });
    }
    this.dispatch({ data: this.data, type: 'gpt-search:update' });
    return;
  };
}
